<template>
  <nav class="crumbs" aria-label="Вы находитесь здесь">
    <template v-for="(item, index) in items" :key="index">
      <NuxtLink v-if="item.to" :to="item.to" class="crumbs__link">{{ item.name }}</NuxtLink>
      <span v-else class="crumbs__current">{{ item.name }}</span>
      <span v-if="index < items.length - 1" class="crumbs__sep">›</span>
    </template>
  </nav>
</template>

<script setup>
import { breadcrumbsLd, jsonLdScript } from "~/utils/jsonLd";

// Крошки заодно отдают разметку BreadcrumbList: по ней в выдаче вместо голого
// адреса показывается путь «Каталог › Египет › Статуэтка»
const props = defineProps({
  // [{ name: "Каталог", to: "/catalog" }, { name: "Египет" }]
  items: { type: Array, required: true },
});

const origin = useRequestURL().origin;

useHead({ script: [jsonLdScript(breadcrumbsLd(origin, props.items))] });
</script>

<style scoped>
.crumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--el-text-color-secondary);
}

.crumbs__link {
  color: var(--el-color-primary);
  text-decoration: none;
}

.crumbs__link:hover {
  text-decoration: underline;
}

.crumbs__current {
  color: var(--el-text-color-regular);
}

.crumbs__sep {
  color: var(--el-border-color);
}
</style>
